<template>
  <div>    
    <v-layout wrap align-center>
      <v-container fluid>
        <v-layout row child-flex wrap>
          <v-flex d-flex xs2 sm1 class="grey lighten-2">
            <div class="text-center">
              <h3 class="primary-color">3</h3>
            </div>
          </v-flex>
          <v-flex d-flex xs10 sm11 class="grey lighten-3">
            <div>
              <h3 class="primary-color">Configurações do gerador de energia solar</h3>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout wrap align-center>
      <div class="col-md-12">   
        <Loader v-if="loader" style="margin-left: 25px" class="pull-left"/>     
        <v-btn
          class="justify-center pull-right"
          color="primary"
          @click="resetFiltros()"
        >LIMPAR FILTROS
        </v-btn>
      </div>
      <v-flex xs12 sm4 d-flex>
        <v-select
          :items="familias"
          item-text="Valor"
          item-value="Id"
          label="Família"
          v-model="projeto.filtros.familia"
          @change="filterOptions('FAMILIA', $event)"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <v-select
          :items="estruturas"
          item-text="Valor"
          item-value="Id"
          label="Estrutura desejada"
          v-model="projeto.filtros.estrutura"
          @change="filterOptions('TIPO_ESTRUTURA', $event)"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4>
        <v-subheader class="pl-0">Cobertura desejada</v-subheader>
        <v-slider @change="filterOptions('COBERTURA')" v-model="projeto.filtros.cobertura" thumb-label min="1"></v-slider>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <v-select
          :items="inversores"
          item-text="Valor"
          item-value="Id"
          label="Inversor"
          v-model="projeto.filtros.inversor"
          @change="filterOptions('MARCA_INVERSOR', $event)"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <v-select
          :items="paineis"
          item-text="Valor"
          item-value="Id"
          label="Painel"
          v-model="projeto.filtros.painel"
          @change="filterOptions('MARCA_PAINEL', $event)"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <v-select
          :items="tensoes"
          item-text="Valor"
          item-value="Id"
          label="Tensão"
          v-model="projeto.filtros.tensao"
          @change="filterOptions('TENSAO_SAIDA', $event)"
        ></v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import axios from 'axios';

  export default {
    name: 'ProjectGeneratorConfiguration',
    computed: {
      ...mapGetters([
        'projeto',
        'familias',
        'estruturas',
        'tensoes',
        'inversores',
        'paineis',
        'caracteristicasBasicas'
      ])
    },
    data() {
      return {
        filtro: [],
        optionChanged: '',
        loader: false,
        primeira: true
      }
    },
    updated() {
        if (this.primeira == true) {
            this.fetchSelectors();
            this.filterOptions('TODOS', '');
            this.primeira = false;
        }
    },
    methods: {
      ...mapActions(['fetchSelectors', 'calculatePotencia', 'clearFiltros']),
      resetFiltros() {
        this.clearFiltros();
        this.fetchSelectors();
      },
      filterOptions: async function(option, event) {
        this.loader = true;
        this.optionChanged = option;            
        await this.calculatePotencia();
        
        this.filtro = [];
        if (this.projeto.filtros.familia > 0)
          this.filtro.push(this.projeto.filtros.familia);
        if (this.projeto.filtros.estrutura > 0)
          this.filtro.push(this.projeto.filtros.estrutura);
        if (this.projeto.filtros.inversor > 0)
          this.filtro.push(this.projeto.filtros.inversor);
        if (this.projeto.filtros.painel > 0)
          this.filtro.push(this.projeto.filtros.painel);
        if (this.projeto.filtros.tensao > 0)
          this.filtro.push(this.projeto.filtros.tensao);

        this.filtro = this.filtro.filter(this.onlyUnique);
        await this.getFiltros();
        this.loader = false;
      },
      onlyUnique(value, index, self) { 
        return self.indexOf(value) === index;
      },
      async getFiltros() {
        const url = `${this.$apiUrl}CalculadoraSolar.svc/getatributoscalculadora`

        const body = {
          filtros: this.filtro,
          potencia: this.caracteristicasBasicas.generatorCapacity
        };
        
        const response = await axios.post(`${url}`, body);
        
        let filtros = response.data;        

        if (this.optionChanged != 'FAMILIA') {      
          let familias = filtros.filter(c => c.Nome == 'FAMILIA')[0]
          familias = familias.Atributos;
          familias.unshift({Id: 0, Valor: 'Todas'})
          this.$store.commit('setFamilias', familias)
        }

        if (this.optionChanged != 'TIPO_ESTRUTURA') { 
          let estruturas = filtros.filter(c => c.Nome == 'TIPO_ESTRUTURA')[0]
          estruturas = estruturas.Atributos;
          estruturas.unshift({Id: 0, Valor: 'Todas'})
          this.$store.commit('setEstruturas', estruturas)
        }

        if (this.optionChanged != 'TENSAO_SAIDA') { 
          let tensoes = filtros.filter(c => c.Nome == 'TENSAO_SAIDA')[0]
          tensoes = tensoes.Atributos;
          tensoes.unshift({Id: 0, Valor: 'Todas'})
          this.$store.commit('setTensoes', tensoes)
        }

        if (this.optionChanged != 'MARCA_INVERSOR') { 
          let inversores = filtros.filter(c => c.Nome == 'MARCA_INVERSOR')[0]
          inversores = inversores.Atributos;
          inversores.unshift({Id: 0, Valor: 'Todos'})
          this.$store.commit('setInversores', inversores)
        }

        if (this.optionChanged != 'MARCA_PAINEL') { 
          let paineis = filtros.filter(c => c.Nome == 'MARCA_PAINEL')[0]                                    
          paineis = paineis.Atributos;
          paineis.unshift({Id: 0, Valor: 'Todos'})                                
          this.$store.commit('setPaineis', paineis)     
        }
      }      
    },    
    // created() {
    //   this.fetchSelectors();
    //   this.calculatePotencia();
    // }
  }
</script>

<style scoped>
</style>
